import { Box, IconButton, Tooltip } from "@mui/material"
import QrCode2Icon from '@mui/icons-material/QrCode2';

interface ButtonSeriesProps {
  onClick: () => void
  disabled?: boolean
}

export default function ButtonSeries({
  onClick,
  disabled = false
}: ButtonSeriesProps
) {

  return (
    <Box sx={{ display: 'flex', gap: '1rem' }}>
      <Tooltip title="Cargar Series">
        <IconButton
          disabled={disabled}
          onClick={async () => {
            onClick()
          }}
        >
          <QrCode2Icon color={
            disabled
              ? 'inherit'
              : 'primary'
          } />
        </IconButton>
      </Tooltip>
    </Box>
  )

}